/**
 * @generated SignedSource<<7e115048bc83610b996e55dc7ced9185>>
 * @relayHash 7056584fa631ab9a5c7475a20fbb78da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4800e0583467ba3a2c2e6eb1f2a25e27bdd5aa3c2d95112d6aa65102ac89466

import type { ConcreteRequest } from 'relay-runtime';
export type useAgentSessionsLiveUpdatesSubscription$variables = {
  accountId: string;
  cloudId: string;
  conversationWorkspaceAri: string;
  workspaceAri: string;
};
export type useAgentSessionsLiveUpdatesSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly session: {
      readonly __typename: "AgentSession";
      readonly agentAccountId: string | null;
      readonly conversationChannel: {
        readonly __typename: "AgentConversationChannel";
        readonly id: string | null;
        readonly name: string | null;
        readonly readStatus: boolean | null;
      } | null;
      readonly convoAiAgentId: string | null;
      readonly expireTime: AGG$DateTime | null;
      readonly id: string | null;
      readonly isRovo: boolean | null;
      readonly lastStateChangeAt: AGG$Long | null;
      readonly state: string | null;
      readonly stateReason: string | null;
    } | null;
    readonly sessionAri: string;
    readonly sessionId: string;
  } | null;
};
export type useAgentSessionsLiveUpdatesSubscription = {
  response: useAgentSessionsLiveUpdatesSubscription$data;
  variables: useAgentSessionsLiveUpdatesSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conversationWorkspaceAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "ConvoAiInboxSessionChanged",
    "kind": "LinkedField",
    "name": "convoai_onInboxSessionChanged",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "sessionAri"
      },
      {
        "kind": "ScalarField",
        "name": "sessionId"
      },
      {
        "concreteType": "AgentSession",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "state"
          },
          {
            "kind": "ScalarField",
            "name": "stateReason"
          },
          {
            "kind": "ScalarField",
            "name": "expireTime"
          },
          {
            "kind": "ScalarField",
            "name": "lastStateChangeAt"
          },
          {
            "kind": "ScalarField",
            "name": "isRovo"
          },
          {
            "kind": "ScalarField",
            "name": "agentAccountId"
          },
          {
            "kind": "ScalarField",
            "name": "convoAiAgentId"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "workspaceAri",
                "variableName": "conversationWorkspaceAri"
              }
            ],
            "concreteType": "AgentConversationChannel",
            "kind": "LinkedField",
            "name": "conversationChannel",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "readStatus"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "selections": (v6/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "c4800e0583467ba3a2c2e6eb1f2a25e27bdd5aa3c2d95112d6aa65102ac89466",
    "metadata": {},
    "name": "useAgentSessionsLiveUpdatesSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "cd738b7c2e0bfd8fbfa1f07d4d69dff2";

export default node;
